import { useCMS } from './useCMS';

// 有效 WhatsApp 號碼（CMS site.whatsapp.number）。
// 客人號碼未落實前回傳空字串——調用方以「即將開通」降級顯示，不輸出壞連結（phone= 空）。
export function useWhatsAppNumber(): string {
  const { getValue } = useCMS();
  return getValue('site.whatsapp.number', '').replace(/\D/g, '');
}

export function waLink(number: string, text: string): string {
  return `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(text)}`;
}
